import { useEffect } from "react";

const scrollOpts: ScrollIntoViewOptions = {
  block: "start",
  inline: "nearest",
};

const PROGRAM_DRAWER_SELECTOR = 'dialog[data-testid="drawer"]';

function isFullyVisibleInViewport(el: HTMLElement): boolean {
  const { top, bottom, left, right } = el.getBoundingClientRect();
  const vv = window.visualViewport;
  const viewHeight = vv?.height ?? window.innerHeight;
  const viewWidth = vv?.width ?? window.innerWidth;
  return top >= 0 && bottom <= viewHeight && left >= 0 && right <= viewWidth;
}

export function useCenterKeyboardFocusInView(enabled = true): void {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") return;

    const onFocusIn = (event: FocusEvent) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      if (target === document.body || target === document.documentElement) return;
      if (target.closest(PROGRAM_DRAWER_SELECTOR)) return;

      try {
        if (!target.matches(":focus-visible")) return;
      } catch {
        return;
      }

      requestAnimationFrame(() => {
        if (isFullyVisibleInViewport(target)) return;
        target.scrollIntoView(scrollOpts);
      });
    };

    document.addEventListener("focusin", onFocusIn, true);
    return () => document.removeEventListener("focusin", onFocusIn, true);
  }, [enabled]);
}
